import React, { useState, useEffect } from 'react';
import ConfirmationDialog from './ConfirmationDialog';
import InputWithIcon from '../InputWithIcon';
import RoleChooser from '../RoleChooser';
import emailIcon from '../../assets/users/email.svg';

const AddUserConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  onCancel
}) => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [role, setRole] = useState("USER");

  // Reset state when dialog opens/closes
  useEffect(() => {
    if (open) {
      setEmail("");
      setEmailError(false);
      setErrorMessage("");
      setRole("USER");
    }
  }, [open]);
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (emailError) {
      setEmailError(false);
    }
    if (errorMessage) {
      setErrorMessage("");
    }
  };

  const handleConfirm = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError(true);
      return;
    }
    
    try {
      await onConfirm(email, role);
      // If successful, the parent will handle closing the dialog
    } catch (error) {
      setErrorMessage(error.message || 'לא הצלחנו לשלוח אימייל למשתמש, תוכל לנסות שוב יותר מאוחר?');
    }
  };

  return (
    <ConfirmationDialog
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      title="הוספת משתמש למחלקה"
      confirmText="אישור"
      cancelText="ביטול"
      onCancel={onCancel}
    >
      <>
        <InputWithIcon
          icon={emailIcon}
          placeholder="אימייל"
          value={email}
          onChange={handleEmailChange}
          style={{ 
            borderColor: emailError ? 'red' : '',
          }}
        />
        {emailError && <p style={{ textAlign: 'right', color: 'red', fontSize: 'smaller' }}>נא הזן כתובת אימייל תקינה</p>}
        <div style={{ height: '10px' }}></div>
        <RoleChooser
          value={role}
          onChange={(e) => setRole(e.target.value)}
          size="medium"
        />
        
        <div className="info-label">
          <div className="info-icon">i</div>
          <p className="info-text">אם המשתמש אינו קיים במערכת, תשלח לו הזמנה להצטרף ל mashlom.me. אחרי ההרשמה, המשתמש יצורף למחלקה.</p>
        </div>

        {errorMessage && <p style={{ color: 'red', marginTop: '1rem' }}>{errorMessage}</p>}
      </>
    </ConfirmationDialog>
  );
};

export default AddUserConfirmationDialog;
